import Session from '@/utils/Session';
import React,{useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Connection from '../../utils/Connection';

interface LoginProps {
    onOtpRequested: (contactInfo: string) => void;
}

const Login: React.FC<LoginProps> = ({ onOtpRequested }) => {
    const [email, setEmail] = useState<string>('');
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        Session.setUserType('clinician');
        e.preventDefault();
        const url = Connection.baseUrl('login-code');
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Tenant-Code': 'lot',
                },
                body: JSON.stringify({ email }),
            });

            if (!response.ok) {
                throw new Error('Failed to send OTP. Please try again.');
            }

            if(response?.status === 200){
                onOtpRequested(email);
                navigate('/otp', { state: { email } });
            }

            
        } catch (error: any) { /* empty */ }
    };

    return (
        <div className="login-container">
            <h2 className="login-title">Login Page</h2>
            <form onSubmit={handleLogin}>
                <div className="form-group">
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="submit-button">Request OTP</button>
            </form>
        </div>
    );
};

export default Login;
